import { render, staticRenderFns } from "./LegacyBubbleChartWidget.vue?vue&type=template&id=541c0338&"
import script from "./LegacyBubbleChartWidget.vue?vue&type=script&lang=js&"
export * from "./LegacyBubbleChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports